import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

import { IncentiveOfferOperation } from 'modules/incentivesMarket/types';

export type IncentiveOfferOperationSummary = {
  completed: number;
  pending: number;
  totalUnits: number;
  totalAmount: number;
};

export type GetIncentiveOfferOperationsResponse = {
  data: IncentiveOfferOperation[];
  total: number;
  summary?: IncentiveOfferOperationSummary;
};

export const getIncentiveOfferOperations = async ({
  incentiveOfferId,
  societyId,
  seller,
  page = 1,
  items = 10,
}: {
  incentiveOfferId: string;
  societyId: string;
  seller?: string | string[];
  page?: number;
  items?: number;
}): Promise<GetIncentiveOfferOperationsResponse> => {
  const { data } = await axiosV2.get('/incentiveOfferOperations', {
    params: { incentiveOfferId, societyId, seller, page, items },
  });

  const decodedData = (await decryptResponse(
    data
  )) as GetIncentiveOfferOperationsResponse;

  return decodedData;
};
